import './style.scss';
import {gsap} from "gsap";

export function headerBlock() {
  const header = document.querySelector('header');
  if (!header) return;
  
  const burgerMenu = header.querySelector('.burger-menu');
  const menuLinks = header.querySelector('.navbar');
  if (!burgerMenu) return;
  
  const burgerSpans = burgerMenu.querySelectorAll('span');
  gsap.set(burgerSpans, {transformOrigin: 'center'});
  
  // ✅ Define burger timeline safely
  const burgerTl = gsap.timeline({paused: true});
  burgerTl
      .to(burgerSpans, {
        y: gsap.utils.wrap([`10px`, 0, `-10px`]),
        duration: 0.25,
      })
      .set(burgerSpans, {autoAlpha: gsap.utils.wrap([1, 0, 1])})
      .to(burgerSpans, {rotation: gsap.utils.wrap([45, 0, -45])})
      .set(burgerSpans, {rotation: gsap.utils.wrap([45, 0, 135])});
  
  const overlay = header.querySelector(".overlay");
  const fullScreenMenu = header.querySelector(".full-screen-menu");
  
  // ✅ Function to close all panel menus
  function closeAllMenus(callback) {
    const openMenu = header.querySelector(".menu-panel.active");
    const openLi = header.querySelector(".panel-button.active");
    
    if (openMenu) {
      openMenu.classList.remove("active");
      openMenu.classList.add("closing");
      
      if (openLi) openLi.classList.remove("active");
      
      openMenu.addEventListener("transitionend", function handler() {
        openMenu.classList.remove("closing");
        openMenu.removeEventListener("transitionend", handler);
        if (callback) callback();
      });
    } else {
      if (callback) callback();
    }
  }
  
  // ✅ Burger menu toggle
  // ✅ Burger menu toggle (close panels when opening or closing)
  burgerMenu.addEventListener('click', function () {
    if (burgerMenu.classList.contains('burger-menu-active')) {
      // 🔹 When closing the burger, also close any open panel first
      closeAllMenus(() => {
        overlay.classList.remove('active');
        fullScreenMenu.classList.remove('active');
        header.classList.remove('hover-state');
        document.documentElement.classList.remove('modal-opened');
        
        // Then close the burger menu itself
        burgerMenu.classList.remove('burger-menu-active');
        menuLinks.classList.remove('header-links-active');
        header.classList.remove('header-active');
        burgerTl.reverse();
      });
    } else {
      // 🔹 When opening the burger, close any open panel first
      closeAllMenus(() => {
        overlay.classList.remove('active');
        fullScreenMenu.classList.remove('active');
        header.classList.remove('hover-state');
        document.documentElement.classList.remove('modal-opened');
        
        // Then open the burger menu
        burgerMenu.classList.add('burger-menu-active');
        menuLinks.classList.add('header-links-active');
        header.classList.add('header-active');
        burgerTl.play();
        document.documentElement.classList.add('modal-opened');
        
        // Animate menu items
        gsap.fromTo(
            menuLinks.querySelectorAll('.menu-item , .cta-wrappers'),
            {y: 30, autoAlpha: 0},
            {y: 0, autoAlpha: 1, stagger: 0.05, duration: 0.4, delay: 0.5}
        );
      });
    }
  });
  
  
  const headerItems = header.querySelectorAll(".panel-button");
  const headerLinks = header.querySelectorAll(".menu-item");
  
  // ✅ Handle panel button clicks
  headerItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = item.dataset.target;
      const targetMenu = document.getElementById(targetId);
      if (!targetMenu) return;
      
      const isAlreadyActive = targetMenu.classList.contains("active");
      
      if (isAlreadyActive) {
        closeAllMenus(() => {
          overlay.classList.remove("active");
          fullScreenMenu.classList.remove("active");
          header.classList.remove("hover-state");
          document.documentElement.classList.remove("modal-opened");
          
          // 🔹 Re-enable header links
          headerLinks.forEach(link => link.style.pointerEvents = "auto");
        });
      } else {
        closeAllMenus(() => {
          targetMenu.classList.add("active");
          item.classList.add("active");
          overlay.classList.add("active");
          fullScreenMenu.classList.add("active");
          
          // ✅ Mobile: add hover-state when panel opens
          if (window.matchMedia("(max-width: 991px)").matches) {
            header.classList.add("hover-state");
          }
          
          // 🔹 Disable header links when a panel is open
          headerLinks.forEach(link => link.style.pointerEvents = "none");
          
          // 🔹 Add modal-opened class to <html>
          document.documentElement.classList.add("modal-opened");
        });
      }
    });
  });
  
  // ✅ Overlay and close buttons behavior
  overlay.addEventListener("click", () => {
    closeAllMenus(() => {
      overlay.classList.remove("active");
      fullScreenMenu.classList.remove("active");
      header.classList.remove("hover-state");
      document.documentElement.classList.remove("modal-opened");
      
      // 🔹 Re-enable header links
      headerLinks.forEach(link => link.style.pointerEvents = "auto");
    });
  });
  
  header.querySelectorAll(".menu-panel .close").forEach((btn) => {
    btn.addEventListener("click", () => {
      closeAllMenus(() => {
        overlay.classList.remove("active");
        fullScreenMenu.classList.remove("active");
        header.classList.remove("hover-state");
        document.documentElement.classList.remove("modal-opened");
        
        // 🔹 Re-enable header links
        headerLinks.forEach(link => link.style.pointerEvents = "auto");
      });
    });
  });
  
  ////// ✅ Mega menu hover state and idle team-image warming
  const menuItems = header.querySelectorAll('.menu-item-has-children');
  const desktopMedia = window.matchMedia('(min-width: 992px)');
  const teamMemberCache = new Map();
  const teamOffsetStorageKey = 'ezyquip-header-team-offset';

  function getTeamBaseOffset() {
    try {
      const storedOffset = Number.parseInt(
          window.sessionStorage.getItem(teamOffsetStorageKey),
          10
      );

      if (Number.isInteger(storedOffset) && storedOffset >= 0) {
        return storedOffset;
      }

      const newOffset = Math.floor(Math.random() * 1000);
      window.sessionStorage.setItem(teamOffsetStorageKey, String(newOffset));
      return newOffset;
    } catch (error) {
      return Math.floor(Math.random() * 1000);
    }
  }

  const baseOffset = getTeamBaseOffset();

  function revealTeamPanel(panel) {
    requestAnimationFrame(() => {
      panel.style.opacity = 1;
    });
  }

  function createDetachedTeamImage(imageHtml, priority) {
    if (!imageHtml) return null;

    const template = document.createElement('template');
    template.innerHTML = imageHtml.trim();
    const sourceImage = template.content.querySelector('img');

    if (!sourceImage) return null;

    const image = new Image();
    [...sourceImage.attributes].forEach(({name, value}) => {
      if (!['src', 'srcset', 'sizes'].includes(name)) {
        image.setAttribute(name, value);
      }
    });
    image.fetchPriority = priority;
    image.loading = 'eager';
    image.decoding = 'async';
    image.sizes = sourceImage.sizes;
    image.srcset = sourceImage.srcset;
    image.src = sourceImage.src;
    return image;
  }

  function prepareTeamMember(index, priority = 'low') {
    const cachedTeamMember = teamMemberCache.get(index);

    if (cachedTeamMember) {
      if (priority === 'high') {
        cachedTeamMember.priority = 'high';
        if (cachedTeamMember.image) {
          cachedTeamMember.image.fetchPriority = 'high';
        }
      }

      return cachedTeamMember.promise;
    }

    const cacheEntry = {
      image: null,
      priority,
      promise: null,
    };
    const offset = baseOffset + index;

    cacheEntry.promise = (async () => {
      const response = await fetch(
          ajaxUrl + '?action=get_random_team&offset=' + offset,
          {
            credentials: 'same-origin',
            priority,
          }
      );

      if (!response.ok) throw new Error('Unable to load team member');

      const data = await response.json();
      if (!data || !data.name) throw new Error('Empty team member response');

      const image = createDetachedTeamImage(
          data.image_html,
          cacheEntry.priority
      );
      cacheEntry.image = image;

      if (image && typeof image.decode === 'function') {
        await image.decode().catch(() => {});
      }

      return {data, image};
    })().catch((error) => {
      teamMemberCache.delete(index);
      throw error;
    });

    teamMemberCache.set(index, cacheEntry);
    return cacheEntry.promise;
  }

  function renderTeamMember(panel, teamMember) {
    const profileInfo = document.createElement('div');
    profileInfo.className = 'profile-info';

    ['name', 'job', 'location'].forEach((fieldName) => {
      const field = document.createElement('p');
      field.className = `subheading-12 ${fieldName}`;
      field.textContent = teamMember.data[fieldName] ?? '';
      profileInfo.append(field);
    });

    panel.replaceChildren(profileInfo);

    if (teamMember.image) {
      const picture = document.createElement('picture');
      picture.className = 'profile-photo';
      teamMember.image.fetchPriority = 'high';
      picture.append(teamMember.image);
      panel.append(picture);
    }

    panel.dataset.teamState = 'loaded';
    revealTeamPanel(panel);
  }

  async function loadTeamMember(menuItem, index) {
    const panel = menuItem.querySelector('.team-member-wrapper');

    if (!panel || panel.dataset.teamState === 'loaded') return;

    panel.dataset.teamState = 'loading';

    try {
      const teamMember = await prepareTeamMember(index, 'high');
      renderTeamMember(panel, teamMember);
    } catch (error) {
      delete panel.dataset.teamState;
    }
  }

  function syncHeaderHoverState() {
    if (!desktopMedia.matches) {
      header.classList.remove('hover-state');
      return;
    }

    const menuIsActive = [...menuItems].some((item) => (
      item.matches(':hover') || item.contains(document.activeElement)
    ));

    header.classList.toggle('hover-state', menuIsActive);
  }

  menuItems.forEach((menuItem, index) => {
    const requestTeamMember = () => loadTeamMember(menuItem, index);

    menuItem.addEventListener('pointerenter', () => {
      if (desktopMedia.matches) header.classList.add('hover-state');
      requestTeamMember();
    });
    menuItem.addEventListener('pointerleave', () => {
      requestAnimationFrame(syncHeaderHoverState);
    });
    menuItem.addEventListener('focusin', () => {
      if (desktopMedia.matches) header.classList.add('hover-state');
      requestTeamMember();
    });
    menuItem.addEventListener('focusout', () => {
      requestAnimationFrame(syncHeaderHoverState);
    });
    menuItem.addEventListener('click', requestTeamMember);
  });

  desktopMedia.addEventListener('change', syncHeaderHoverState);

  function warmTeamMembersWhenIdle() {
    const connection = navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
    const usesDataSaver = connection?.saveData;
    const usesSlowConnection = ['slow-2g', '2g'].includes(
        connection?.effectiveType
    );

    if (
      !desktopMedia.matches ||
      document.hidden ||
      usesDataSaver ||
      usesSlowConnection
    ) {
      return;
    }

    const warmSequentially = async () => {
      for (const [index, menuItem] of [...menuItems].entries()) {
        if (!menuItem.querySelector('.team-member-wrapper')) continue;
        await prepareTeamMember(index, 'low').catch(() => {});
      }
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmSequentially, {timeout: 4000});
    } else {
      window.setTimeout(warmSequentially, 2500);
    }
  }

  if (document.readyState === 'complete') {
    warmTeamMembersWhenIdle();
  } else {
    window.addEventListener('load', warmTeamMembersWhenIdle, {once: true});
  }
  
  ////// end hover
  
  // ✅ Click outside to close desktop mega menus
  const megaMenus = header.querySelectorAll(".menu-item.menu-item-has-children");
  const desktopMegaWrappers = document.querySelectorAll(".mega-menu-wrapper");
  
  document.addEventListener("click", (event) => {
    const isMenuClick = event.target.closest(".menu-item.menu-item-has-children");
    const isMegaMenuClick = event.target.closest(".mega-menu-wrapper");
    
    if (!isMenuClick && !isMegaMenuClick) {
      megaMenus.forEach((menuItem) => menuItem.classList.remove("active"));
      desktopMegaWrappers.forEach((wrapper) => wrapper.classList.remove("active"));
      header.classList.remove("active");
    }
  });
  
  // ✅ Gear Search Logic
  const gearSearchForm = document.querySelector('#menu-search form.wrapper');
  if (gearSearchForm) {
    const gearSearchRadios = gearSearchForm.querySelectorAll('input[name="gear-search"]');
    gearSearchRadios.forEach(radio => {
      radio.addEventListener("change", function () {
        // Remove 'active' from all gear search labels
        gearSearchRadios.forEach(r => {
          if (r.closest('.option-wrapper')) {
            r.closest('.option-wrapper').classList.remove('active');
          }
        });
        // Add 'active' to the selected one
        if (this.checked && this.closest('.option-wrapper')) {
          this.closest('.option-wrapper').classList.add('active');
        }
      });
    });
    
    gearSearchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      
      let selectedType = "hire";
      const checkedRadio = gearSearchForm.querySelector('input[name="gear-search"]:checked');
      if (checkedRadio) selectedType = checkedRadio.value;
      
      const searchInput = gearSearchForm.querySelector('input[type="search"]');
      const term = searchInput ? searchInput.value.trim() : "";
      
      const baseSiteUrl = typeof ajaxUrl !== 'undefined' ? ajaxUrl.replace('/wp-admin/admin-ajax.php', '') : window.location.origin;
      let url = `${baseSiteUrl}/products/?product-category%5B%5D=gear-${selectedType}`;
      
      if (term) {
        url += `&q=${encodeURIComponent(term)}`;
      }
      
      window.location.href = url;
    });
  }
  
  ////// ✅ intl-tel-input MutationObserver (unchanged)
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (
              node instanceof HTMLElement &&
              node.matches('.intl-tel-input.iti-container') &&
              node.querySelector('.country-list')
          ) {
            document.body.classList.add('model-opened');
          }
        }
        
        for (const node of mutation.removedNodes) {
          if (
              node instanceof HTMLElement &&
              node.matches('.intl-tel-input.iti-container')
          ) {
            document.body.classList.remove('model-opened');
          }
        }
        
        const anyOpen = document.querySelectorAll('.intl-tel-input.iti-container .country-list').length > 0;
        if (!anyOpen) {
          document.body.classList.remove('model-opened');
        }
      }
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
